<template>
  <el-row :gutter="10">
    <el-col :span="6">
      <material-category-table :productLine="this.productLine" />
    </el-col>
    <el-col :span="18">
      <choose-material
        ref="chooseMaterial"
        :type="type"
        :productLine="productLine"
        :mainMaterialCategoryCode="mainMaterialCategoryCode"
        :detailMaterialCategoryCode="detailMaterialCategoryCode"
      />
    </el-col>
  </el-row>
</template>
<script>
import materialCategoryTable from './components/material-category-tree-table'
export default {
  components: {
    materialCategoryTable,
  },
  props: {
    productLine: String,
    type: String,
  },
  data() {
    return {
      mainMaterialCategoryCode: '',
      detailMaterialCategoryCode: '',
    }
  },
  provide() {
    return {
      materialQuery: ({ classLevel, materialCategoryCode, parentCode }) => {
        if (!classLevel) {
          this.mainMaterialCategoryCode = ''
          this.detailMaterialCategoryCode = ''
          return
        }

        if (classLevel === 1) {
          this.mainMaterialCategoryCode = materialCategoryCode
          this.detailMaterialCategoryCode = ''
          return
        }

        this.mainMaterialCategoryCode = parentCode
        this.detailMaterialCategoryCode = materialCategoryCode
      },
    }
  },
  methods: {
    choiceData() {
      return this.$refs.chooseMaterial.choiceData()
    },
  },
}
</script>
